import { render, staticRenderFns } from "./CaseNotifications.vue?vue&type=template&id=b89c68e8"
import script from "./CaseNotifications.vue?vue&type=script&lang=js"
export * from "./CaseNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports